/** @jsx jsx */
import React, { memo } from 'react';

import { jsx } from '@compiled/react';
import { SSRPlacement as Nav4ProjectsSection } from '@post-office/placements/nav-4-projects-section';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { PostOfficeProvider } from '@atlassian/jira-post-office-provider/src/index.tsx';
import { postOfficeNav4ProjectsSectionResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import { PlacementFetchProvider } from '@atlassian/jira-post-office-provider/src/placement-fetch-provider.tsx';
import { usePlacementPreloadedData } from '@atlassian/jira-post-office-provider/src/preload-placement.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import type { DefaultMessagesResponse } from '@post-office/placement-common-v2/types';

type Props = {
	onMessageCountChange?: (numberOfMessages: number) => void;
};

export const Nav4ProjectsSectionPlacement = memo(({ onMessageCountChange }: Props) => {
	const preloadedInitialData = usePlacementPreloadedData(postOfficeNav4ProjectsSectionResource);

	return (
		<UFOSegment name="jira-growth-nav-4-projects-section">
			<JSErrorBoundary
				id="growthNav4ProjectsSection"
				packageName="@atlassian/jira-growth-nav-4-projects-section"
				teamName="Sequoia"
				fallback="unmount"
			>
				<PostOfficeProvider>
					<PlacementFetchProvider resource={postOfficeNav4ProjectsSectionResource}>
						<Nav4ProjectsSection
							// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
							preloadedInitialData={preloadedInitialData as DefaultMessagesResponse | undefined}
							onMessageCountChange={onMessageCountChange}
						/>
					</PlacementFetchProvider>
				</PostOfficeProvider>
			</JSErrorBoundary>
		</UFOSegment>
	);
});
